import { Info } from "lucide-react";

const InternalWorkspaceBanner = () => (
  <section
    className="rounded-2xl sm:rounded-3xl border border-slate-200 bg-slate-50 p-4 sm:p-5"
    role="status"
  >
    <div className="flex items-start gap-3">
      <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white text-slate-600 border border-slate-200">
        <Info size={18} aria-hidden />
      </div>
      <div className="min-w-0">
        <p className="text-[11px] sm:text-xs font-extrabold uppercase tracking-wider text-slate-500">
          Proyek internal
        </p>
        <p className="mt-1 text-sm sm:text-base font-semibold text-slate-800 leading-snug">
          Proyek internal. Tidak ada klien dan escrow Indoteknisi.
        </p>
        <p className="mt-1 text-xs sm:text-sm text-slate-600 leading-relaxed">
          RAB, tim, dan lapangan tetap dipakai untuk kelola kerja. Tidak ada tagihan klien atau pencairan escrow.
        </p>
      </div>
    </div>
  </section>
);

export default InternalWorkspaceBanner;
